import { Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { Button } from "bootstrap-4-react/lib/components";
import PropTypes from 'prop-types';

const PasteAddressModal = (props) => {
    const { modalClass, modalShow, handleClose, saveAddressForm } = props;
    const [address, setAddress] = useState('');

    const handleAddressChange = (e) => {
        setAddress(`${e.target.value}`);
    }

    return (
        <Modal
            className={modalClass || ''}
            size="lg"
            show={modalShow}
            onHide={handleClose}
        >
            <Modal.Header>
                <div className="modal-main-div">
                    <div className="modal-m-text">Paste Address</div>
                </div>
                <div className="modalDeleteWrapper">
                    <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
                </div>

            </Modal.Header>
            <Modal.Body>
                <div className='saveForm'>
                    <div className='emailForm'>
                        <div className='row'>
                            <div className='col-12'>
                                <label htmlFor="toEmail">Enter Address</label>
                                <textarea
                                    onChange={(e) => handleAddressChange(e)}
                                    name='emails'
                                    id="toEmail"
                                    rows={5}
                                    value={address}
                                    className='form-control emailBodyField'
                                    placeholder="Name
Address Line 1
Address Line 2 (Optional)
City, State ZIP"
                                />
                            </div>
                        </div>
                    </div>
                    <div className='formActionsEmailForm'>
                        <Button className="cus-seconday-bg-btn" onClick={handleClose}>Cancel</Button>
                        <button id="saveEmailForm" className='btn cus-seconday-bg-btn' onClick={(e) => saveAddressForm(e, address)} disabled={!address}>Use Address</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

PasteAddressModal.propTypes = {
    modalClass: PropTypes.string,
    modalShow: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    saveAddressForm: PropTypes.func.isRequired
};

export default PasteAddressModal;